import type { HTMLAttributes, ReactNode } from 'react';

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  /** The muted message line. */
  children: ReactNode;
  /** Optional call-to-action slot (e.g. a `<ButtonRouterLink>`). */
  action?: ReactNode;
}

/**
 * Centered muted "nothing here yet" block for empty card bodies / lists.
 * Matches the `.db-empty` shape in the dashboard mock. Composed by the
 * dashboard cards when a VM array is empty.
 */
export function EmptyState({
  children,
  action,
  className,
  ...rest
}: EmptyStateProps) {
  const cls = ['pn-empty', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      <span className="pn-empty-msg">{children}</span>
      {action ? <span className="pn-empty-action">{action}</span> : null}
    </div>
  );
}
